import { ca } from '@cian/analytics';

/**
 * Клик на кнопку Сохранить
 */
export function trackCommentSend() {
  ca('event', {
    name: 'oldevent',
    category: 'ListingFavorites',
    action: 'send_comment',
    label: '',
  });
}
